import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const Section = props => (
    <section className={`section ${props.mod ? (`section_${props.mod}`) : ''}`}>
        <div className={`section__wrapper  ${props.mod ? (`section__wrapper_${props.mod}`) : ''}`}>
            {props.title ? (
                <h3 className={`section__title ${props.mod ? (`section__title_${props.mod}`) : ''}`} title={props.title}>
                    {props.title}
                    {props.button ? <NavLink
                        className={`button section__button ${props.button.className || ''}`}
                        activeClassName=""
                        to={props.button.href}
                    >
                        {props.button.text}
                    </NavLink> : null}
                </h3>) : null}
            <div className={`section__content ${props.mod ? (`section__content_${props.mod}`) : ''}`}>{props.children}</div>
        </div>
    </section>
);

Section.propTypes = {
    children: PropTypes.element.isRequired,
    title: PropTypes.string,
    button: PropTypes.shape({
        href: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        className: PropTypes.string
    }),
    mod: PropTypes.string
};

Section.defaultProps = {
    button: null,
    title: null,
    mod: ''
};

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section.jsx